export const CAMPAIGN_HISTORY_REPORT_ID = 'campaign-history';
